import Select from "../../../Basic/Inputs/Select";

const ProductUnitSelect = ({ unit = null, onSelect = () => {}, style = {}, width = '100px', ...props }) => {
  return (
    <Select
      select={unit}
      list={['шт.', 'уп.', 'пакет', 'набор', "метр"]}
      onSelect={(pr) => onSelect(pr)}
      width={width}
      style={style}
      {...props}
    />
  );
};

export default ProductUnitSelect;
